export type AssetId =
  | 'AST-001'
  | 'AST-002'
  | 'AST-003'
  | 'AST-004'
  | 'AST-005'
  | 'AST-006'
  | 'AST-007'
  | 'AST-008'
  | 'AST-009'
  | 'AST-010'
  | 'AST-011'
  | 'AST-012'
  | 'AST-013'
  | 'AST-014'

export type SectionId =
  | 'SEC-001'
  | 'SEC-002'
  | 'SEC-003'
  | 'SEC-004'
  | 'SEC-005'
  | 'SEC-006'

export interface AssetDefinition {
  id: AssetId
  filename: string
  path: string
  type: 'image' | 'video'
  sectionId: SectionId
  width?: number
  height?: number
  hasAlpha?: boolean
  alt: string
}

export const assets: Readonly<Record<AssetId, AssetDefinition>> = {
  'AST-001': {
    id: 'AST-001',
    filename: '延时 (2).mp4',
    path: '/assets/videos/延时 (2).mp4',
    type: 'video',
    sectionId: 'SEC-001',
    width: 3840,
    height: 2160,
    alt: '宁乡时代奥特莱斯万物来潮青铜万象装置夜景延时视频。',
  },
  'AST-002': {
    id: 'AST-002',
    filename: '图片生成-1786619095815.png',
    path: '/assets/images/图片生成-1786619095815.png',
    type: 'image',
    sectionId: 'SEC-003',
    width: 3840,
    height: 2160,
    alt: '青铜万象主题艺术装置夜景效果图。',
  },
  'AST-003': {
    id: 'AST-003',
    filename: '夜晚-1786640317516.png',
    path: '/assets/images/夜晚-1786640317516.png',
    type: 'image',
    sectionId: 'SEC-003',
    width: 3840,
    height: 2160,
    alt: '花开新岁新春限定主题艺术装置夜景效果图。',
  },
  'AST-004': {
    id: 'AST-004',
    filename: '图片生成-1786623775027.png',
    path: '/assets/images/图片生成-1786623775027.png',
    type: 'image',
    sectionId: 'SEC-002',
    width: 3840,
    height: 2160,
    alt: '万物来潮中央装置与环形市集俯视布局图。',
  },
  'AST-005': {
    id: 'AST-005',
    filename: '图片生成-1786624684746.png',
    path: '/assets/images/图片生成-1786624684746.png',
    type: 'image',
    sectionId: 'SEC-002',
    width: 3840,
    height: 2160,
    alt: '艺术装置与外围主题市集夜景实景融合效果图。',
  },
  'AST-006': {
    id: 'AST-006',
    filename: '图片生成-1786634866097.png',
    path: '/assets/images/图片生成-1786634866097.png',
    type: 'image',
    sectionId: 'SEC-003',
    width: 2480,
    height: 3312,
    hasAlpha: true,
    alt: '东方艺术灯笼细节图。',
  },
  'AST-007': {
    id: 'AST-007',
    filename: '微信图片_20260814141837_353_7.jpg',
    path: '/assets/images/微信图片_20260814141837_353_7.jpg',
    type: 'image',
    sectionId: 'SEC-004',
    width: 736,
    height: 523,
    alt: '全民参与共创涂鸦墙互动现场。',
  },
  'AST-008': {
    id: 'AST-008',
    filename: '微信图片_20260814141838_354_7.jpg',
    path: '/assets/images/微信图片_20260814141838_354_7.jpg',
    type: 'image',
    sectionId: 'SEC-004',
    width: 736,
    height: 1104,
    alt: '游客在涂鸦墙上进行绘画创作特写。',
  },
  'AST-009': {
    id: 'AST-009',
    filename: '微信图片_20260814141551_351_7.jpg',
    path: '/assets/images/微信图片_20260814141551_351_7.jpg',
    type: 'image',
    sectionId: 'SEC-004',
    width: 736,
    height: 983,
    alt: '游客在潮生四羊连线互动墙进行线绳连接操作。',
  },
  'AST-010': {
    id: 'AST-010',
    filename: '微信图片_20260814141550_349_7.jpg',
    path: '/assets/images/微信图片_20260814141550_349_7.jpg',
    type: 'image',
    sectionId: 'SEC-004',
    width: 1200,
    height: 800,
    alt: '线绳连接完成后的网状图形结构。',
  },
  'AST-011': {
    id: 'AST-011',
    filename: '图片生成-1786688708236.png',
    path: '/assets/images/图片生成-1786688708236.png',
    type: 'image',
    sectionId: 'SEC-005',
    width: 2480,
    height: 3312,
    hasAlpha: true,
    alt: '青铜文化四羊方尊展示体验区展牌设计。',
  },
  'AST-012': {
    id: 'AST-012',
    filename: '图片生成-1786690380661.png',
    path: '/assets/images/图片生成-1786690380661.png',
    type: 'image',
    sectionId: 'SEC-005',
    width: 2480,
    height: 3312,
    alt: '展牌序列在奥特莱斯商业街区落地实景渲染图。',
  },
  'AST-013': {
    id: 'AST-013',
    filename: '微信图片_20260814160317_80_2.jpg',
    path: '/assets/images/微信图片_20260814160317_80_2.jpg',
    type: 'image',
    sectionId: 'SEC-005',
    width: 2480,
    height: 3312,
    alt: '展牌概念手绘设计稿。',
  },
  'AST-014': {
    id: 'AST-014',
    filename: '白天-1786638732644.png',
    path: '/assets/images/白天-1786638732644.png',
    type: 'image',
    sectionId: 'SEC-006',
    width: 3840,
    height: 2160,
    alt: '万物来潮花开新岁装置白天全景图。',
  },
}
